import { ITab } from 'helpers/tabs';

let subMenu : ITab[] = [ 
    { title: 'Cloud', url: '/consulting/cloud' },
    { title: 'Architecture', url: '/consulting/architecture' }
];

export default subMenu ;